export class AccountData {
    accountNumber: string;
    bankCode: string;
}